export const errorDescriptions = {
  NOT_FOUND: "Sorry, that page doesn’t exist.",
  INTERNAL_SERVER_ERROR:
    "Sorry, it looks like something’s gone wrong. Our technical team has been informed and we are looking into it. Please try again later.",
  BAD_REQUEST: "Sorry, it looks like something’s gone wrong.",
};

export const errorCategories = {
  INTERNAL_SERVER_ERROR: "INTERNAL_SERVER_ERROR",
  BAD_REQUEST: "BAD_REQUEST",
  NOT_FOUND: "NOT_FOUND",
};

export const getErrorDescription = (errorCategory) => {
  switch (errorCategory) {
    case errorCategories.NOT_FOUND:
      return errorDescriptions.NOT_FOUND;
    case errorCategories.INTERNAL_SERVER_ERROR:
      return errorDescriptions.INTERNAL_SERVER_ERROR;
    default:
      return errorDescriptions.BAD_REQUEST;
  }
};

export const getErrorCategoryFromStatus = (status) => {
  switch (true) {
    case /404/.test(status):
      return errorCategories.NOT_FOUND;
    case /5[0-9]{2}/.test(status):
      return errorCategories.INTERNAL_SERVER_ERROR;
    default:
      return errorCategories.BAD_REQUEST;
  }
};
